<template>
    <div>
        <v-container grid-list-md justify-start>
            <v-layout>
                <v-flex xs12 lg9>
                    <v-card>
                        <v-data-table
                            v-bind:headers="headers"
                            v-bind:items="rosters"
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <tr v-if="is_administration()">
                                    <td>
                                        <team-badge
                                            v-bind:team="getTeamById(props.item.team_id).team"
                                            v-bind:colour="getTeamById(props.item.team_id).colour"
                                            width="120px"
                                        ></team-badge>
                                    </td>
                                    <td class="text-xs-right">{{ props.item.selected_player_ids.length }}</td>

                                    <td class="text-xs-right">
                                        <v-icon
                                            small
                                            class="mr-2"
                                            v-on:click="issueEdit(props.item)"
                                        >
                                            edit
                                        </v-icon>
                                        <v-icon
                                            small
                                            v-on:click="issueDelete(props.item)"
                                        >
                                            delete
                                        </v-icon>
                                    </td>
                                </tr>
                                <tr v-else v-on:click="issueShow(props.item)">
                                    <td>
                                        <team-badge
                                            v-bind:team="getTeamById(props.item.team_id).team"
                                            v-bind:colour="getTeamById(props.item.team_id).colour"
                                            width="120px"
                                        ></team-badge>
                                    </td>
                                    <td class="text-xs-right">{{ props.item.selected_player_ids.length }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import TeamBadge from './TeamBadge.vue'

export default {
    name: 'RostersGrid',
    props: ['admin', 'rosters', 'administration'],
    data() {
        return {
            exact: true,
            headers: [
                {
                    text: 'Team',
                    align: 'left',
                    sortable: false,
                    value: 'team',
                    width: '120px'
                },
                {
                    text: 'Players',
                    align: 'right',
                    sortable: false,
                    value: 'player_count'
                }
            ]
        }
    },
    methods: {
         is_admin() {
            if (this.admin) {
                return true
            } else {
                return false
            }
        },
         is_administration() {
            if (this.administration) {
                return true
            } else {
                return false
            }
        },
        issueShow(roster) {
            this.$router.push({name: 'rosters_show', params: {id: roster.id}})
        },
        issueEdit(roster) {
            this.$router.push({name: 'admin_rosters_edit', params: {id: roster.id}})
        },
        issueDelete(roster) {
            this.$store.dispatch('deleteRoster', {
                roster: roster
            })
        },
        getTeamById(team_id) {
            return this.$store.getters.getTeamById(team_id)
        }
    },
    components: {
        TeamBadge
    }
}
</script>

<style scoped></style>
